import { createIcon } from '@chakra-ui/react';

export const DotMoreIcon = createIcon({
  displayName: 'DotMoreIcon',
  path: (
    <>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none">
        <path
          d="M3.33333 6.66797C2.6 6.66797 2 7.26797 2 8.0013C2 8.73464 2.6 9.33464 3.33333 9.33464C4.06667 9.33464 4.66667 8.73464 4.66667 8.0013C4.66667 7.26797 4.06667 6.66797 3.33333 6.66797Z"
          stroke="#3F3F46"
          strokeWidth="1.5"
        />
        <path
          d="M12.6673 6.66797C11.934 6.66797 11.334 7.26797 11.334 8.0013C11.334 8.73464 11.934 9.33464 12.6673 9.33464C13.4007 9.33464 14.0007 8.73464 14.0007 8.0013C14.0007 7.26797 13.4007 6.66797 12.6673 6.66797Z"
          stroke="#3F3F46"
          strokeWidth="1.5"
        />
        <path
          d="M7.99935 6.66797C7.26602 6.66797 6.66602 7.26797 6.66602 8.0013C6.66602 8.73464 7.26602 9.33464 7.99935 9.33464C8.73268 9.33464 9.33268 8.73464 9.33268 8.0013C9.33268 7.26797 8.73268 6.66797 7.99935 6.66797Z"
          stroke="#3F3F46"
          strokeWidth="1.5"
        />
      </svg>
    </>
  ),
});
